import http from "./httpService";

const Urlapi = "https://api-mobileapp.advanceagro.net";

export async function getLPRlist(
  start = "",
  end = "",
  branchid = "",
  id =0,
  search = "",
  pageSize = 1000,
  pageNumber = 1
) {
  //reportevent(string startdate,string enddate,string branchid,int id =0, string search = "", int pageSize = 30, int pageNumber = 1)
  return http.get(
    "/LCP/reportevent?startdate=" +
      start +
      "&enddate=" +
      end +
      "&branchid=" +
      branchid +
      "&id="+id +
      "&pageSize=" +
      pageSize +
      "&pageNumber=" +
      pageNumber +
      "&search=" +
      search
  );
}
export async function getlprdevice() {
  return http.get("/LCP/LPRlist");
}

export default {
  getLPRlist,
  getlprdevice,
};
